module.exports = __webpack_public_path__ + "static/media/thropybig.3ae876f1.svg";